import { render, staticRenderFns } from "./NavbarLogin.vue?vue&type=template&id=048f1f89&scoped=true&"
import script from "./NavbarLogin.vue?vue&type=script&lang=js&"
export * from "./NavbarLogin.vue?vue&type=script&lang=js&"
import style0 from "./NavbarLogin.vue?vue&type=style&index=0&id=048f1f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f1f89",
  null
  
)

export default component.exports